import React from 'react';
import BlockedSubscribedMiddleContent from './_partials/BlockedSubscribedMiddleContent';
import NeedsSubscriptionMiddleContent from './_partials/NeedsSubscriptionMiddleContent';
import PremiumLockedMiddleContent from './_partials/PremiumLockedMiddleContent';
import WatchersOnlyMiddleContent from './_partials/WatchersOnlyMiddleContent';
import BlockedMiddleContent from './_partials/BlockedMiddleContent';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
var DeviationThumbMiddleContent = function (_a) {
    var deviation = _a.deviation, thumbHeight = _a.thumbHeight, thumbWidth = _a.thumbWidth, className = _a.className, children = _a.children;
    var blockType = useDeviationBlockType(deviation);
    switch (blockType) {
        case 'matureFilter':
            return (React.createElement(BlockedMiddleContent, { deviation: deviation, thumbWidth: thumbWidth, thumbHeight: thumbHeight, className: className }));
        case 'premiumFolder':
            return (React.createElement(PremiumLockedMiddleContent, { deviation: deviation, thumbWidth: thumbWidth, thumbHeight: thumbHeight, className: className }));
        case 'watchersOnly':
            return (React.createElement(WatchersOnlyMiddleContent, { deviation: deviation, thumbWidth: thumbWidth, thumbHeight: thumbHeight, className: className }));
        case 'subsOnly':
            return (React.createElement(NeedsSubscriptionMiddleContent, { deviation: deviation, thumbWidth: thumbWidth, thumbHeight: thumbHeight, className: className }));
        case 'subBlocked':
            return (React.createElement(BlockedSubscribedMiddleContent, { thumbWidth: thumbWidth, thumbHeight: thumbHeight, className: className }));
        default:
            return React.createElement(React.Fragment, null, children);
    }
};
DeviationThumbMiddleContent.displayName = 'DeviationThumbMiddleContent';
export default DeviationThumbMiddleContent;
//# sourceMappingURL=DeviationThumbMiddleContent.js.map